<template>
    <div class="div-footer-wrap2">
        <div class="div-footer2">
            <div class="div-qrcode2">
                <span class="footer-weixin-title2">{{webInfo.footerImageText}}</span>
                <img :src="webInfo.footerImage" class="footer-weixin2"/>
            </div>
            <div class="div-footer-desc2">
                <div>{{webInfo.copyright}}</div>
                <div>{{webInfo.address}}</div>
                <div>{{webInfo.otherinfo}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "H5Footer",
        data(){
            return {
                webInfo:{}
            }
        },
        created(){
            this.getWebInfo();
        },
        methods:{
            getWebInfo(){
                this.$axios.get("/front/company/webInfo").then(res=>{
                    if(res.data.success){
                        this.webInfo=res.data.result
                    }
                });
            },
        }
    }
</script>

<style scoped>
    /* 底部 */
    .div-footer-wrap2{
        height: 152px;
        background-color: rgba(0,43,74,0.8);
        margin-top:-5px;
        display: flex;
        align-items: center;
        padding: 0 30px;
    }
    .div-footer2{
        display: flex;
        height: 120px;
        align-items: center;
        justify-content: space-between;
    }
    .div-qrcode2{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .div-footer-desc2{
        flex:1;
        color:#D9EFFF;
        font-size: 12px;
        margin-left: 10px;
        line-height: 26px;
        text-align: left;
    }
    .div-footer2 .footer-weixin-title2{
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
    }
    .div-footer2 .footer-weixin2{
        height: 80px;
        width: 80px;
        background-color: rgba(211, 227, 238,1);
    }


</style>
